import React from 'react';
import './Legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="page-header">
        <div className="container">
          <h1>ゴルマチアプリ・サービス利用規約</h1>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p>この利用規約（以下「本利用規約」といいます。）は、株式会社 Gol-Pal（以下「当社」といいます。）が提供する「ゴルマチ」アプリ（以下「本アプリ」といいます。）及び、本アプリを用いて提供・利用する「ゴルマチ」又は「GOLMACHI」という名称のゴルフ愛好者向けゴルフエンタメサービス（以下「本サービス」といいます。）の利用に関する条件を、本サービス及び本アプリを利用するお客様（以下「会員」といいます。）と当社との間で定めるものです。</p>
            <p>本アプリ及び本サービスの利用に際しては、本利用規約の全文をお読みいただいたうえで、本利用規約に同意し、当社が定める方法により、会員登録を完了させる必要があります。会員登録が完了した時点で、本利用規約を内容とする本アプリ及び本サービス利用契約が、当社及び会員の間で、締結されます。</p>
            <p>本利用規約に同意されない場合、本アプリ及び本サービスをご利用いただくことはできませんので、直ちに、本アプリのダウンロード、インストール、又は利用を中止してください。</p>
            <p>また、本サービス及び本アプリは、未成年者による利用を認めておりません。未成年者の方は、直ちに、本アプリのダウンロード、インストール、又は利用を中止してください。</p>

            <div className="legal-chapter">
              <h2>第1章 総則</h2>

              <div className="legal-section">
                <h3>第1条（本サービスの概要）</h3>
                <p>本サービスは、日本国内在住の成人（高校生を除く）を対象とし、一緒にゴルフを回る相手を探すサポートを行うものです。なお、本サービスの利用により、そのような相手が見つかることを保証するものではありません。</p>
              </div>

              <div className="legal-section">
                <h3>第2条（適用）</h3>
                <p>1. 当社は、会員に対して、本利用規約に基づき、本アプリの利用を許諾し、本サービスを提供します。</p>
                <p>2. 本アプリ上又は当社ウェブサイト上で、本アプリ及び本サービスの利用に関するルール・ガイドライン等を掲載している場合は、当該ルール・ガイドライン等は本利用規約の一部を構成するものとします。当該ルール・ガイドライン等その他の本利用規約外の説明等と、本利用規約の内容とが異なる場合は、本利用規約の規定が優先して適用されるものとします。</p>
                <p>3. 会員は、本利用規約を誠実に遵守するものとし、本アプリ及び本サービスの利用に関し当社からの指示等がある場合はこれに従うものとします。</p>
              </div>

              <div className="legal-section">
                <h3>第3条（秘密保持）</h3>
                <p>会員は、本アプリ及び本サービスに関連して、当社が会員に対して秘密に取り扱うことを求めて開示した情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱い、第三者に開示等をしないものとします。</p>
              </div>

              <div className="legal-section">
                <h3>第4条（権利帰属）</h3>
                <p>1. 当社による本サービスの提供に用いられる全てのコンテンツに関する権利は、全て当社に帰属しています。会員による本サービスの利用は、本コンテンツに関する権利の譲渡又は利用許諾を意味するものではなく、会員は、本コンテンツに関して何らの権利も取得しません。</p>
                <p>2. 会員が本アプリを用いて登録したプロフィール及びコンテンツ（位置情報、画像データ、テキストを含みます）（以下「本コンテンツ」といいます。）並びに、他の会員との間のメッセージ等（以下、あわせて「会員メッセージ等」といいます。）に関する知的財産権その他一切の権利は、会員又はこれらについて法的権利を有するものに帰属します。</p>
                <p>3. 会員は、当社に対して、本コンテンツについて、本サービスの提供・維持・改善・不正対策・広告宣伝等を目的とし、日本の国内外で、無償かつ非独占的に利用（複製、上映、公衆送信、展示、頒布、譲渡、貸与、翻訳、翻案、出版を含みます）する権利を期限の定めなく許諾（サブライセンス権を含みます）することとします。また、会員は、会員メッセージ等に関して著作者人格権を行使しないものとします。</p>
                <p>4. 当社は、本アプリのメンテナンス、又は本サービスの提供（本利用規約又は法令に反する会員メッセージ等の有無の確認やクレーム等への対応を含みます。）に必要と判断する場合、会員メッセージ等の複製、削除、開示等を行います。会員は、これら利用について、予め同意するものとします。</p>
              </div>
            </div>

            <div className="legal-chapter">
              <h2>第2章 会員情報、利用資格、アカウント等</h2>

              <div className="legal-section">
                <h3>第5条（会員の登録情報の取扱い）</h3>
                <p>1. 当社による会員の登録情報の取り扱いについては、当社の別途定めるプライバシーポリシーの定めによるものとします。会員はこのプライバシーポリシーに従って当社が会員の情報を取り扱うことについて同意するものとします。</p>
                <p>2. 本アプリ上で、会員の登録情報は、原則として会員の自己申告を基に表示されます。当社が、各会員の登録情報が正しいことを保証するものではありません。当社は、会員に対して、当社が合理的に必要と判断をした場合、会員の本人確認等に関する資料の提供その他の協力を求めることができます。</p>
                <p>3. 当社は、下記第6条に定める利用資格を欠く等の理由により、会員に対して、会員登録の拒否、本サービス提供等の拒否、本サービス利用契約の解除などを行った場合であっても、その理由について一切開示義務を負いません。</p>
                <p>4. 当社は、下記第6条に定める利用資格を欠くにもかかわらず、登録手続きを行った者（但し、同3号については過失による場合を除きます。）に対し、損害賠償を請求することができるものとします。</p>
              </div>

              <div className="legal-section">
                <h3>第6条（利用資格）</h3>
                <p>1. 以下の各号のいずれかの事由に該当する方は会員になることはできません。該当する方は登録手続きを行わないでください。会員登録後に、同条の違反の疑いが生じた場合、当社の判断により、当該会員への通知の有無にかかわらず、会員登録を無効とすることができ、また、当社は、本サービスを提供する債務その他一切の債務を負わないものとします。</p>
                <ul>
                  <li>（1）既に本サービスの会員であるにも関わらず重複して会員登録をする場合</li>
                  <li>（2）本サービスに関する金銭債務の不履行、その他利用契約に違反したことを理由として会員登録を解除されたことがある場合。ただし、当社が特別に認めた場合を除きます。</li>
                  <li>（3）当社に対して負担する何らかの債務の履行について遅滞が生じている場合</li>
                  <li>（4）会員の登録情報に虚偽の記載等があった場合</li>
                  <li>（5）未成年者又は高等学校に学生として在籍する場合</li>
                  <li>（6）成年被後見人、被保佐人又は被補助人のいずれかであり、後見人、補佐人又は補助人の同意等を得ていなかった場合</li>
                  <li>（7）反社会的勢力等（暴力団、暴力団員、反社会的勢力、その他これに準ずる者をいいます。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合</li>
                  <li>（8）その他上記に準ずるものとして当社が不適当と判断した場合</li>
                </ul>
                <p>2. 会員は、会員登録の手続を行うことにより、反社会的勢力等でないこと、及び資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていないこと、将来においてもこれらに該当しないことを表明し、保証します。</p>
              </div>

              <div className="legal-section">
                <h3>第7条（会員の登録情報の変更）</h3>
                <p>1. 会員は、登録情報に変更又は誤りがある場合、本アプリを用いて、直ちに登録情報を修正しなければなりません。</p>
                <p>2. 当社は、会員が前項の修正を怠ったことにより、当社からの誤送金、当社からの通知の不到達、本サービス利用契約の解除、その他の事由により損害を被った場合であっても、一切責任を負わないものとします。</p>
              </div>

              <div className="legal-section">
                <h3>第8条（パスワード等の管理）</h3>
                <p>1. 会員は、本サービスの利用に際して登録するパスワードを、会員の責任において厳重に管理するものとします。</p>
                <p>2. 第三者が会員のID及びパスワードを用いて、本アプリ又は本サービスを利用した場合、当該行為は当該会員の行為とみなされるものとし、当社は、これにより当該会員が被った損害を賠償する責任を一切負わないものとします。</p>
                <p>3. 前項の規定は、当社の故意又は重大な過失により第三者にパスワードが流出したことに起因する場合は適用されないものとします。</p>
              </div>
            </div>

            <div className="legal-chapter">
              <h2>第3章 本サービス内容等</h2>

              <div className="legal-section">
                <h3>第9条（本アプリの使用方法等）</h3>
                <p>1. 会員は、本アプリを通じて、マッチングをした他の会員との間で、①ゴルフの日時や場所、②ゴルフのプレーフィー及び交通費などの費用の負担者、③その他ゴルフをプレーする上で合理的に必要となる事項に関して話し合い、ゴルフを楽しむことができます。</p>
                <p>2. 前項に定める話し合いと会員間の合意に関して、当社は、当事者とはなりません。かかる話し合いや合意に関するトラブル（交渉中のトラブル等、ラウンド中の事故やゴルフ場への往復時の事故、ゴルフエンタメサービス提供の前後の事故を含みます。）は、当事者である会員間で解決するものとし、これに対し、本利用規約に明記した場合を除き、当社は、責任を負いません。</p>
                <p>3. 本アプリでは、一定のサービスを利用するには、有料のサブスクリプションを行う必要が生じる場合があります。サブスクリプションに関する最新のプランやその他の利用条件に関する詳細は、本アプリ上の「ゴルマチストア」及び「キャンセルポリシー」をご覧ください。</p>
              </div>

              <div className="legal-section">
                <h3>第10条（禁止事項）</h3>
                <p>1. 会員は、本アプリの利用時及び対象ラウンドにおいて、以下の行為をしてはなりません。</p>
                <ul>
                  <li>（1）相手方の事前の承諾なく相手方の写真や動画を撮影し、又は録音をする行為</li>
                  <li>（2）相手方に対する性的な言動、ストーキング、嫌がらせ、ハラスメント、マウンティング又はこれらに類する行為</li>
                  <li>（3）相手方が不要と感じる指導やアドバイス等を継続又は繰り返す行為</li>
                  <li>（4）相手方に対する誹謗中傷、脅迫、暴力的と判断されるような行為</li>
                  <li>（5）相手方の個人情報を無断で収集、蓄積する行為</li>
                  <li>（6）会員を誤認させる表現をする行為</li>
                  <li>（7）第三者になりすます行為</li>
                  <li>（8）当社、他の会員、第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為</li>
                  <li>（9）虚偽又は事実と異なる情報を本アプリに登録する行為、登録情報を不正に改ざんする行為</li>
                  <li>（10）当社のシステム、サーバー、ネットワークに負担をかけ、妨害し、又は障害等を発生させる行為</li>
                  <li>（11）営業、宣伝、広告、勧誘、その他営利を目的とする行為、マルチ商法等に関する行為</li>
                  <li>（12）宗教、政治等に関する行為</li>
                  <li>（13）法令又は公序良俗に反する行為</li>
                  <li>（14）その他当社が不適切と判断する行為</li>
                </ul>
                <p>2. 当社は、会員が前項に違反する行為を行った疑いが生じた場合、当社の判断により、当該会員への通知の有無にかかわらず、会員登録を無効とすることができ、また、当社は、本サービスを提供する債務その他一切の債務を負わないものとします。また、当社は、警察、所轄官庁その他の機関に通報する場合があります。</p>
                <p>3. 前項の結果について、当該会員は、異議を述べないものとし、当社は、当該会員に対し、いかなる損害賠償責任も負わず、いかなる補償も行わないものとします。</p>
              </div>
            </div>

            <div className="legal-chapter">
              <h2>第4章 本サービスの中止、変更、終了</h2>

              <div className="legal-section">
                <h3>第11条（本サービスの内容等の変更、終了）</h3>
                <p>1. 当社は、当社の都合により、本アプリの機能、本サービスの内容等を変更し、又はその一部若しくは全部の提供を、会員への通知の有無にかかわらず、終了することができます。</p>
                <p>2. 当社は、本条に基づき当社が行った措置に基づき会員に生じた損害について、当社に故意又は重大な過失がある場合を除き、一切の責任を負いません。</p>
              </div>

              <div className="legal-section">
                <h3>第12条（本利用規約の変更）</h3>
                <p>当社は、本利用規約を変更できるものとします。当社は、本利用規約を変更した場合には、本利用規約に定める方法により、会員に当該変更内容を通知するものとし、当該変更内容の通知後、会員が本アプリを利用した場合又は当社の定める相当期間内に解約の手続きをとらなかった場合には、会員は、本利用規約の変更に同意したものとします。</p>
              </div>

              <div className="legal-section">
                <h3>第13条（本サービス利用契約上の地位の譲渡等）</h3>
                <p>1. 会員は、当社の事前の書面による承諾を得た場合を除き、本サービス利用契約上の地位を第三者に承継させ、又は本契約から生じる権利義務の全部若しくは一部を第三者に譲渡し、引き受けさせ若しくは担保に供することはできません。</p>
                <p>2. 当社は、本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い本サービス利用契約上の地位、本サービス利用契約に基づく権利及び義務並びに会員の登録事項その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、会員は、かかる譲渡につき本項において予め同意したものとします。</p>
              </div>
            </div>

            <div className="legal-chapter">
              <h2>第5章 本サービスの無保証、損害賠償の制限、免責、紛争等</h2>

              <div className="legal-section">
                <h3>第14条（本サービスの内容等の無保証、変更、終了）</h3>
                <p>1. 当社は、本サービスの提供を受けることができる会員を、会員登録の有無にかかわらず、当社が合理的に必要と判断する条件を満たした者に限定することができるものとします。</p>
                <p>2. 当社は、本アプリ及び本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みますが、これらに限りません）がないことを保証しておりません。</p>
                <p>3. 当社は、本アプリ及び本サービスが、全てのパソコン、スマートフォン、タブレット端末等およびOSに対応することを保証しておりません。</p>
              </div>

              <div className="legal-section">
                <h3>第15条（免責及び損害賠償）</h3>
                <p>1. 会員が、本アプリ若しくは本サービスを利用して他の会員との間で送受信した情報等、他の会員と行ったゴルフプレーに関して生じるトラブル（ラウンド中のトラブルの他、ゴルフ場への往復・送迎時のトラブル、その他のゴルフプレー前後のトラブルを含みます。）、苦情等、その他の本アプリ若しくは本サービスを利用して知り合った会員との間のトラブル、苦情等の一切の問題は、当該会員の間で解決するものとし、当社は一切責任を負いません。</p>
                <p>2. 当社は、本アプリ又は本サービスの利用に関連して発生した会員の損害について、当社に故意又は重大な過失がある場合を除き一切責任を負わないものとします。</p>
                <p>3. 当社は、本アプリ又は本サービスを提供する機器の故障、トラブル、停電等ならびに通信回線の異常等当社の予測を超えた事由又はシステムの障害等により、会員の登録情報その他会員に関する情報が消失した場合、これにより発生した損害について一切責任を負わないものとします。</p>
                <p>4. 当社は、会員が本規約の違反又は本アプリ若しくは本サービスの適切な利用を逸脱したことにより生じた損害について一切責任を負わないものとします。</p>
              </div>

              <div className="legal-section">
                <h3>第16条（通知）</h3>
                <p>1. 当社から会員への通知は、本アプリの機能（チャット機能等）を利用して各会員に本アプリ上で通知する方法、すべての会員又は特定の属性を有する複数の会員向けに本アプリの機能（お知らせ機能等）を利用して告知する方法、会員の連絡先として登録された電子メールアドレスに電子メールを送信する方法のいずれかにより行います。ただし、本アプリの不具合等により上記機能が利用できない場合は、当社のホームページへ掲載する方法その他の合理的な代替手段により行うことがあります。</p>
                <p>2. 前項の規定に基づく通知は、それぞれ以下の時点から効力を生じるものとします。</p>
                <ul>
                  <li>（1）本アプリの機能を利用する場合：当該会員が本アプリを起動すれば通知又は告知が確認できる状態になったとき（本アプリの起動の有無を問わない）。</li>
                  <li>（2）電子メールを送信する方法による場合：当社から電子メールの送信がなされたとき。なお、登録した電子メールアドレス宛に送信することにより通知は完了したとみなされ、これらに誤りがある又は変更がなされた等により到達しなかった場合でもその効力に影響はないものとします。</li>
                  <li>（3）当社のホームページへ掲載する方法：当社のホームページに掲載後、相当期間が経過したとき。</li>
                  <li>（4）その他の合理的な代替手段による方法：通常であれば、会員が通知を確認し、又は受領できる状態となったとき。実際に確認又は受領したか否かは問わないものとします。</li>
                </ul>
              </div>

              <div className="legal-section">
                <h3>第17条（準拠法）</h3>
                <p>本利用規約は、抵触法を除き、日本法に準拠し、解釈されます。</p>
              </div>

              <div className="legal-section">
                <h3>第18条（合意管轄）</h3>
                <p>本利用規約に起因又は関連して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
              </div>
            </div>

            <div className="legal-chapter">
              <h2>第6章 その他</h2>

              <div className="legal-section">
                <h3>第19条（苦情等の連絡先）</h3>
                <p>本サービス又は本アプリの利用その他に関する苦情等は、本アプリの問い合わせ機能を用いてご連絡ください。同機能を利用できない場合などは、以下にご連絡ください。</p>
                <div className="contact-info">
                  <p>【社名】株式会社 Gol-Pal</p>
                  <p>【住所】〒150-0031 東京都渋谷区桜丘町23番17号シティコート桜丘408</p>
                  <p>【連絡先】info@gol-pal.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;